if (typeof localizationForm === 'undefined') {
    class LocalizationForm extends HTMLElement {
        constructor() {
            super();
            this._boundOpen = this.openSelector.bind(this);
            this._boundClose = this.closeSelector.bind(this);
            this._boundItemClick = this.onItemClick.bind(this);
            this._boundBodyClick = this.onBodyClickEvent.bind(this);
        }

        connectedCallback() {
            if (this._initialized) return;
            this._initialized = true;
            this.elements = {
                input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
                button: this.querySelector('button'),
                panel: this.querySelector('ul'),
            };
            if (this.elements.button && this.elements.panel) {
                this.elements.button.addEventListener('click', this._boundOpen);
                this.elements.button.addEventListener('focusout', this._boundClose);
            }
            this.querySelectorAll('a').forEach(item => item.addEventListener('click', this._boundItemClick));
            document.body.addEventListener('click', this._boundBodyClick);
        }
    
        onItemClick(event) {
            event.preventDefault();
            event.stopPropagation();
            if (!this.elements?.input) return;
            var value = event.currentTarget && event.currentTarget.getAttribute('data-value');
            if (value) {
                this.elements.input.value = value;
                if (this.elements.button && this.elements.panel) {
                    this.elements.panel.setAttribute('hidden', '');
                    this.elements.button.setAttribute('aria-expanded', 'false');
                }
                this.querySelector('form')?.submit();
            }
        }
    
        openSelector() {
            if (!this.elements?.button || !this.elements?.panel) return;
            this.elements.button.focus();
            var isExpanded = this.elements.button.getAttribute('aria-expanded') === 'true';
            if (isExpanded) {
                this.elements.panel.setAttribute('hidden', '');
                this.elements.panel.classList.remove('show');
                this.elements.button.setAttribute('aria-expanded', 'false');
            } else {
                this.elements.panel.removeAttribute('hidden');
                this.elements.panel.classList.add('show');
                this.elements.button.setAttribute('aria-expanded', 'true');
            }
        }
    
        closeSelector(event) {
            if (!this.elements?.button || !this.elements?.panel) return;
            var related = event.relatedTarget;
            if (this.elements.panel.contains(related)) return;
            // Safari: relatedTarget is often null when dropdown opens (focus moves to "nowhere").
            // Closing here would shut the panel before the user can click an option. Rely on
            // body click to close when clicking outside; only close on focusout when focus
            // moved to a known element (e.g. another button or tabbing away).
            if (related === null) return;
            var shouldClose = related && related.nodeName === 'BUTTON';
            if (shouldClose) {
                var self = this;
                setTimeout(function () {
                    self.elements.button.setAttribute('aria-expanded', 'false');
                    self.elements.panel.setAttribute('hidden', '');
                    self.elements.panel.classList.remove('show');
                }, 0);
            }
        }
    
        onBodyClickEvent(event) {
            if (!this.elements?.button || !this.elements?.panel) return;
            if (this.contains(event.target)) return;
            this.elements.panel.setAttribute('hidden', '');
            this.elements.panel.classList.remove('show');
            this.elements.button.setAttribute('aria-expanded', 'false');
        }
    }
    
    customElements.define('localization-form', LocalizationForm);

    var localizationForm = LocalizationForm;
}